export default __webpack_public_path__ + "static/media/restoran1.eef57d91.jpg";